import React from "react";
import Carousel from "react-bootstrap/Carousel";
// import { useParams } from "react-router-dom";

const HomeCarousel = ({ imgs }) => {
  // const { slug } = useParams();

  // Add BANNER.jpg for UAE country only
  // const bannerImage = { image: "/BANNER.jpg" };
  // const displayImages = slug === "ae" ? [bannerImage, ...imgs] : imgs;
  const displayImages = imgs;

  return (
    <Carousel fade className="mt-4">
      {displayImages.map((element, index) => {
        return (
          <Carousel.Item key={index}>
            <img className="d-block w-100" src={element.image} alt="img" onError={(e) => {
                e.target.src = 'https://ui-avatars.com/api/?name=..&background=59C6C9&color=fff&size=800';
                e.target.style.height = '287px';
                e.target.style.objectFit = 'cover';
                e.target.style.fontSize = '10px';
              }} />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};

export default HomeCarousel;
